export function canInsertSibling(nodes) {
    return [...nodes].filter(
        node => this.actions.canInsertSibling(node)
    )
}

export async function insertSiblingAfter(nodes) {
    await this.execute(
        () => this.actions.insertSiblingAfter(nodes)
    )
}

export async function insertSiblingBefore(nodes) {
    await this.execute(
        () => this.actions.insertSiblingBefore(nodes)
    )
}
